import type { PolarYesNoUndefined } from "@stryker/core/types/section";
import PolarQuestion from "@/components/job/PolarQuestion";
import { Typography } from "@/components/ui/typography";

export type AxialLoadsPolar = {
  design_axial_loads: PolarYesNoUndefined;
  is_component_straight_line: PolarYesNoUndefined;
  do_you_want_to_take_into_account_any_additional_forces_and_moments: PolarYesNoUndefined;
};
type AxialLoadsChecksProps = {
  onHandleYesNo: (payload: { value: PolarYesNoUndefined; key: keyof AxialLoadsPolar }) => void;
  polarQuestions: AxialLoadsPolar;
};
export default function AxialLoadsChecks({ onHandleYesNo, polarQuestions }: AxialLoadsChecksProps) {
  return (
    <>
      <PolarQuestion
        shouldRender
        question="Do you want to design for axial loads?"
        onNoClick={() => {
          onHandleYesNo({ value: "no", key: "design_axial_loads" });
        }}
        onYesClick={() => {
          onHandleYesNo({ value: "yes", key: "design_axial_loads" });
        }}
        selection={polarQuestions.design_axial_loads}
      />
      <PolarQuestion
        question="Is the component a straight line? I.e. no odd geometries, tees, 90s, 45s, reducers, dummy legs"
        shouldRender={polarQuestions.design_axial_loads === "yes"}
        onNoClick={() => {
          onHandleYesNo({ value: "no", key: "is_component_straight_line" });
        }}
        onYesClick={() => {
          onHandleYesNo({ value: "yes", key: "is_component_straight_line" });
        }}
        selection={polarQuestions.is_component_straight_line}
      />
      {polarQuestions.is_component_straight_line === "no" && (
        <Typography variant="text-md" weight="semibold" className="text-primary-500">
          Based on your inputs, this repair cannot be calculated for axial loads. Only straight lines can be canlced for
          axial loads.
        </Typography>
      )}

      <PolarQuestion
        shouldRender={polarQuestions.is_component_straight_line === "yes"}
        question="Do you want to take into account any additional forces and moments?(consult enginnering if unsure)"
        onNoClick={() => {
          onHandleYesNo({ value: "no", key: "do_you_want_to_take_into_account_any_additional_forces_and_moments" });
        }}
        onYesClick={() => {
          onHandleYesNo({ value: "yes", key: "do_you_want_to_take_into_account_any_additional_forces_and_moments" });
        }}
        selection={polarQuestions.do_you_want_to_take_into_account_any_additional_forces_and_moments}
      />
    </>
  );
}
